export default "__VITE_ASSET__BXnFmLvK__"